// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3gLzt","question":"styles_question__2gRbL","inputVisibleButton":"styles_inputVisibleButton__2b5F2","note":"styles_note__1Cele"};